import React from "react";
import { X, Zap, Wrench, Building2, Paintbrush, ChevronRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const ICONS = { electrical: Zap, mechanic: Wrench, structure: Building2, finishing: Paintbrush };
const FACILITIES = [
  { key: "electrical", color: "#D97706" },
  { key: "mechanic", color: "#059669" },
  { key: "structure", color: "#2563EB" },
  { key: "finishing", color: "#7C3AED" },
];

export default function FacilityPicker({ onSelect, onClose, categories, title }) {
  const { t } = useLanguage();
  const list = categories && categories.length ? FACILITIES.filter((f) => categories.includes(f.key)) : FACILITIES;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="mb-5 flex items-center justify-between">
          <h3 className="text-lg font-bold text-slate-900">{title || t("select_facility_type")}</h3>
          <button onClick={onClose}>
            <X className="h-5 w-5 text-slate-400" />
          </button>
        </div>
        <div className="space-y-2.5">
          {list.map((f) => {
            const Icon = ICONS[f.key];
            return (
              <button
                key={f.key}
                data-testid={`facility-${f.key}`}
                onClick={() => onSelect(f.key)}
                className="flex w-full items-center gap-3 rounded-xl border-s-4 bg-slate-50 px-4 py-3.5 text-start transition-colors hover:bg-slate-100"
                style={{ borderInlineStartColor: f.color }}
              >
                <Icon className="h-6 w-6" style={{ color: f.color }} />
                <span className="flex-1 text-base font-semibold" style={{ color: f.color }}>
                  {t(f.key)}
                </span>
                <ChevronRight className="h-5 w-5 text-slate-300" />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
